import { io } from 'socket.io-client';
import { getCookie } from './helpers.js';

// "undefined" means the URL will be computed from the `window.location` object
const URL =
  process.env.NODE_ENV === 'production'
    ? `${process.env.REACT_APP_SERVER_URL}`
    : `${process.env.REACT_APP_SERVER_URL}`;

let token = getCookie('token');

export const socket = io.connect(`${process.env.REACT_APP_SERVER_URL}`, {
  secure: true,
  reconnection: true,
  rejectUnauthorized: false,
  query: { token }
});
